module.exports = __webpack_public_path__ + "img/flower.5a91f4a6.png";